import { useEffect } from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Label } from "@/components/ui/label";

export type TimePeriod = 'week' | 'month' | '3months' | '6months' | 'year';

interface TimePeriodSelectorProps {
  value: TimePeriod;
  onChange: (period: TimePeriod) => void;
}

const TIME_PERIODS: { value: TimePeriod; label: string }[] = [
  { value: 'week', label: 'Past Week' },
  { value: 'month', label: 'Past Month' },
  { value: '3months', label: 'Past 3 Months' },
  { value: '6months', label: 'Past 6 Months' },
  { value: 'year', label: 'Past Year' },
];

const STORAGE_KEY = 'transaction_time_period';

export function TimePeriodSelector({ value, onChange }: TimePeriodSelectorProps) {
  // Persist selection to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, value);
  }, [value]);

  const handleValueChange = (newValue: string) => {
    onChange(newValue as TimePeriod);
  };

  return (
    <div className="space-y-2">
      <Label htmlFor="time-period">Time Period</Label>
      <Select value={value} onValueChange={handleValueChange}>
        <SelectTrigger id="time-period" className="w-[180px]">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {TIME_PERIODS.map((period) => (
            <SelectItem key={period.value} value={period.value}>
              {period.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}

// Helper function to get initial time period from localStorage
export function getInitialTimePeriod(): TimePeriod {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored && TIME_PERIODS.some(p => p.value === stored)) {
    return stored as TimePeriod;
  }
  return 'week'; // Default to 'week'
}
